import {
  SubscriptionBalanceInfo,
  useGetSubscriptionIdQuery,
  useSubscriptionBalanceSubscription,
} from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function BalanceEventsSubscription() {
  const accountId = useActiveAccountId();

  const { data: subscriptionIdData } = useGetSubscriptionIdQuery({
    variables: { accountId },
    skip: !accountId,
  });

  const accountSubscriptionId = subscriptionIdData?.account?.subscription?.id;

  useSubscriptionBalanceSubscription({
    variables: { scope: { update: { accountSubscriptionId } } },
    skip: !accountSubscriptionId,
    onData: ({ client: { cache }, data: { data: result } }) => {
      const payload = result?.accountSubscription;
      if (payload?.__typename !== 'UpdateAccountSubscriptionPayload') return;

      cache.updateFragment(
        {
          id: cache.identify({
            __typename: 'AccountSubscription',
            id: accountSubscriptionId,
          }),
          fragment: SubscriptionBalanceInfo,
          fragmentName: 'SubscriptionBalanceInfo',
        },
        (previousData) => ({
          ...previousData,
          balance: payload.accountSubscription?.balance,
        })
      );
    },
  });

  return null;
}
